import {memo} from "react";
import {Tab, Box} from "@mui/material";
import {TabList, TabPanel, TabContext} from "@mui/lab";

import {useAppStore} from "../Stores";
import {getLabelConfig} from "../Utils";
import {BaseFormLabelType} from "../Types";

export const TabManager: React.FC = memo(() => {
  const labelType = useAppStore.use.labelType();
  const config = getLabelConfig(labelType);

  if (!config) {
    throw new Error('Impossible de récupérer la configuration du type d\'étiquette ' + labelType + '.');
  }

  const labels = useAppStore.use.labels();
  const currentTab = useAppStore.use.currentTab();
  const setCurrentTab = useAppStore.use.setCurrentTab();

  const LabelFormComponent = config.components.form;

  if (!currentTab) {
    throw new Error('Impossible de récupérer l\'étiquette actuelle.');
  }

  return (
    <TabContext value={currentTab}>
      <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
        <TabList
          onChange={(_, value) => setCurrentTab(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {labels.map(
            (label: BaseFormLabelType) => <Tab key={label.id} value={label.id.toString()} label={label.name || 'Étiquette'}/>
          )}
        </TabList>
      </Box>
      {labels.map(
        function (label: BaseFormLabelType) {
          return (
            <TabPanel key={label.id} value={label.id.toString()} keepMounted>
              <LabelFormComponent id={label.id} isFirst={labels[0].id === label.id} />
            </TabPanel>
          );
        }
      )}
    </TabContext>
  );
});

export default TabManager;
